import React, { useState, useEffect } from "react";
import { Menu, X, DollarSign, Users, LayoutDashboard, LogIn, UserCircle2 } from "lucide-react";
import LogoutButton from "../LogoutButton";

// استفاده درست از env (بهتره برگرده به .env باشه، ولی الان که هاردکد کردی هم اوکیه)
const API_URL = 'https://financial2.deepmine.ir';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    const handleResize = () => window.innerWidth >= 1024 && setIsMenuOpen(false);

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const syncAuthState = () => {
      const hasUserId = !!sessionStorage.getItem("user_id");
      const hasProfile = !!sessionStorage.getItem("user_profile");
      setIsLoggedIn(hasUserId || hasProfile);
    };

    syncAuthState();
    window.addEventListener("storage", syncAuthState);
    window.addEventListener("focus", syncAuthState);

    return () => {
      window.removeEventListener("storage", syncAuthState);
      window.removeEventListener("focus", syncAuthState);
    };
  }, []);

  const mentorLink = `${API_URL}/mentors`;
  const dashboardLink = `${API_URL}/dashboard`;
  const profileLink = "/profile";
  const loginLink = "/login";

  return (
    <>
      {isMenuOpen && (
        <div
          className="fixed inset-0 bg-black/40 backdrop-blur-sm z-40 lg:hidden"
          onClick={() => setIsMenuOpen(false)}
        />
      )}

      <header
        className={`
          fixed top-0 left-0 right-0 z-50 transition-all duration-300
          ${scrolled ? "bg-surface/98 backdrop-blur-xl shadow-lg" : "bg-surface/90"}
          border-b border-border
        `}
      >
        <div className="flex items-center justify-between h-16 px-4 md:px-6 max-w-7xl mx-auto w-full">
          {/* لوگو */}
          <div className="flex items-center gap-3 md:gap-4">
            <div className="flex items-center justify-center w-10 h-10 bg-primary rounded-xl shadow-md">
              <DollarSign className="w-6 h-6 text-white" strokeWidth={2.5} />
            </div>
            <div className="hidden sm:block">
              <h1 className="text-lg font-bold text-text-primary leading-tight">
                دستیار مالی ارزیابی
              </h1>
              <p className="text-xs text-text-secondary font-medium">
                چت هوشمند با هوش مصنوعی
              </p>
            </div>
          </div>

          {/* دسکتاپ */}
          <nav className="hidden lg:flex items-center gap-8">
            <a href={mentorLink} className="flex items-center gap-2 text-text-primary hover:text-primary font-medium transition-colors">
              <Users className="w-5 h-5" />
              منتور ها
            </a>
            <a href={dashboardLink} className="flex items-center gap-2 text-text-primary hover:text-primary font-medium transition-colors">
              <LayoutDashboard className="w-5 h-5" />
              داشبورد
            </a>
            <a href={isLoggedIn ? profileLink : loginLink} className="flex items-center gap-2 text-text-primary hover:text-primary font-medium transition-colors">
              {isLoggedIn ? <UserCircle2 className="w-5 h-5" /> : <LogIn className="w-5 h-5" />}
              {isLoggedIn ? "پروفایل" : "ورود"}
            </a>
            {isLoggedIn && <LogoutButton />}
          </nav>

          {/* موبایل */}
          <button
            onClick={() => setIsMenuOpen(v => !v)}
            aria-label={isMenuOpen ? "بستن منو" : "باز کردن منو"}
            className="lg:hidden p-2 rounded-lg hover:bg-muted transition-colors"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* منوی موبایل — کاملاً اصلاح شده */}
        <div
          className={`
            lg:hidden bg-surface border-t border-border shadow-2xl
            transition-all duration-300 overflow-hidden
            ${isMenuOpen ? "max-h-screen opacity-100" : "max-h-0 opacity-0"}
          `}
        >
          <div className="p-6 space-y-8">
            <div className="text-center pb-6 border-b border-border/30 sm:hidden">
              <p className="text-xl font-bold text-text-primary">دستیار مالی ارزیابی</p>
              <p className="text-sm text-text-secondary mt-1">چت هوشمند با هوش مصنوعی</p>
            </div>

            <nav className="flex flex-col space-y-3">
              <a
                href={mentorLink}
                className="flex items-center justify-center gap-3 py-4 px-6 text-lg font-semibold rounded-2xl text-text-primary hover:text-primary hover:bg-primary/10 active:scale-95 transition-all"
              >
                <Users className="w-6 h-6" />
                منتور ها
              </a>
              <a
                href={dashboardLink}
                className="flex items-center justify-center gap-3 py-4 px-6 text-lg font-semibold rounded-2xl text-text-primary hover:text-primary hover:bg-primary/10 active:scale-95 transition-all"
              >
                <LayoutDashboard className="w-6 h-6" />
                داشبورد
              </a>
              <a
                href={isLoggedIn ? profileLink : loginLink}
                className="flex items-center justify-center gap-3 py-4 px-6 text-lg font-semibold rounded-2xl text-text-primary hover:text-primary hover:bg-primary/10 active:scale-95 transition-all"
              >
                {isLoggedIn ? <UserCircle2 className="w-6 h-6" /> : <LogIn className="w-6 h-6" />}
                {isLoggedIn ? "پروفایل" : "ورود"}
              </a>
            </nav>

            {isLoggedIn && (
              <div className="pt-mx-6 px-6 pt-6 border-t border-border/30">
                <LogoutButton className="w-full" />
              </div>
            )}
          </div>
        </div>
      </header>
    </>
  );
}
